export default "__VITE_ASSET__b339cddf__"